export default function tableLocalization() {
    return {
        // Pagination
        page: 'Puslapis',
        rowsPerPage: 'Eilučių per puslapį',
        goToFirst: 'Eiti į pirmą puslapį',
        goToLastPage: 'Eiti į paskutinį puslapį',
        goToNextPage: 'Eiti į kitą puslapį',
        goToPreviousPage: 'Eiti į ankstesnį puslapį',
        showHideColumns: 'Rodyti/paslėpti stulpelius',

        // Sorting
        sortByColumnAsc: 'Rūšiuoti didėjančia tvarka',
        sortByColumnDesc: 'Rūšiuoti mažėjančia tvarka',
        sortAscending: 'Rūšiuoti didėjančia tvarka',
        sortDescending: 'Rūšiuoti mažėjančia tvarka',
        clearSort: 'Išvalyti rūšiavimą',

        // Filtering
        filterByColumn: 'Filtruoti...',
        filterByPlaceholder: 'Filtruoti...',
        clearFilter: 'Išvalyti filtrą',
        clearFilters: 'Išvalyti filtrus',

        // Column Actions
        showAllColumns: 'Rodyti visus stulpelius',
        hideAllColumns: 'Paslėpti visus stulpelius',
        resetColumns: 'Atstatyti stulpelius',
        columnActions: 'Stulpelių veiksmai',
        clearSearch: 'Išvalyti paiešką',

        // General Actions
        actions: 'Veiksmai',
        cancel: 'Atšaukti',
        search: 'Paieška',
        showHideFilters: 'Rodyti/slėpti filtrus',
        showHideSearch: 'Rodyti/slėpti paiešką',

        // Toolbar
        toggleDensity: 'Pakeisti tankumą',
        toggleFullScreen: 'Pakeisti viso ekrano režimą',
        toggleVisibility: 'Pakeisti matomumą',

        // Row Actions
        edit: 'Redaguoti',
        delete: 'Ištrinti',
        save: 'Išsaugoti',
        add: 'Pridėti',

        // Miscellaneous
        noRecordsToDisplay: 'Nėra duomenų',
        loading: 'Įkeliama...',
        error: 'Įvyko klaida',
        selectAllRows: 'Pažymėti visas eilutes',
        deselectAllRows: 'Atžymėti visas eilutes',
        selectRow: 'Pažymėti eilutę',
        deselectRow: 'Atžymėti eilutę',
        selectedRows: '{count} pasirinkta eilutė(-ės)',

        // Column Resizing
        aggregatedBy: 'Agreguota pagal',

        hideColumn: 'Paslėpti stulpelį',
        of: 'iš',
    };
};